import { useState } from "react";
import { CardTaps } from "../../../theme/Component/CardTaps";
import { CardTramitesHistory } from "./HistoryImp/CardTramitesHistory";
import { NotesImp } from "./NotesImp/NotesImp";
import { ResumeImp } from "./ResumeImp/ResumeImp";
import { DocumentsImp } from "./DocumentsImp/DocumentsImp";

interface Props {
    _ProcedureIMPID: number;
}

export const HandlerInfoProcess = ({ _ProcedureIMPID }: Props) => {

    const [indexTap, setIndexTap] = useState(0);

    let taps = [
        { id: 0, name: 'Historial', disable: false },
        { id: 1, name: 'Notas', disable: false },
        { id: 2, name: 'Resumen', disable: false },
        { id: 3, name: 'Documentos', disable: false }
    ];

    return (
        <div className="row">
            <div className="col-md-12">

                <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap} >
                    <div className="row">
                        {indexTap === 0 &&
                            <div className="col-md-12">
                                <CardTramitesHistory ID={_ProcedureIMPID} />
                            </div>
                        }
                        {indexTap === 1 &&
                            <div className="col-md-12">
                                <NotesImp Action={{ IDProcedureImp: _ProcedureIMPID }} />
                            </div>
                        }
                        {indexTap === 2 &&
                            <div className="col-md-12">
                                <ResumeImp IDProcedureImp={_ProcedureIMPID} />
                            </div>
                        }
                        {indexTap === 3 &&
                            <div className="col-md-12">
                                <DocumentsImp ID={_ProcedureIMPID} />
                            </div>
                        }
                    </div>
                </CardTaps>
            </div>
        </div>
    )
};